import ng from 'angular';

export class NsjRadioButtonController implements ng.IController {
  public label: string;
  public name: string;
  public ngModel: any;
  public options: { value: any; label: string }[];
  public required: boolean;
  public disabled: boolean;
  public layout: 'vertical' | 'horizontal';
  ngChange?: () => void;

  $onInit() {

    // layout padrão
    if (!this.layout) {
      this.layout = 'vertical';
    }

  }

}
